import { render, staticRenderFns } from "./products-expand.vue?vue&type=template&id=3ade3579&scoped=true"
import script from "./products-expand.vue?vue&type=script&lang=js"
export * from "./products-expand.vue?vue&type=script&lang=js"
import style0 from "./products-expand.vue?vue&type=style&index=0&id=3ade3579&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade3579",
  null
  
)

export default component.exports